/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Budget_DescInputs */

const en_mk_tb_budget_desc = /** @type {(inputs: Mk_Tb_Budget_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a payer and reserve an amount per session. Unreported costs stay unknown; reservations remain until reconciled. Provider usage outside Bystep follows that account's limits.`)
};

const id_mk_tb_budget_desc = /** @type {(inputs: Mk_Tb_Budget_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentukan pembayar dan jumlah cadangan per sesi. Biaya yang belum dilaporkan tetap belum diketahui; cadangan ditahan sampai direkonsiliasi. Pemakaian provider di luar Bystep mengikuti batas akun tersebut.`)
};

/**
* | output |
* | --- |
* | "Choose a payer and reserve an amount per session. Unreported costs stay unknown; reservations remain until reconciled. Provider usage outside Bystep follows ..." |
*
* @param {Mk_Tb_Budget_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_budget_desc = /** @type {((inputs?: Mk_Tb_Budget_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Budget_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_budget_desc(inputs)
	return en_mk_tb_budget_desc(inputs)
});